import { Box, Button, ButtonGroup, Grid, Typography } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Divider from "@mui/material/Divider";
import logo from "../../src/public/UCI-Merage-Square.png";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { config } from "../config";
import { logout } from "../lib/api/Auth";
import { useUserInfoContext } from "../lib/contexts/UserInfoContext";
import { useChatSessionsContext } from "../lib/contexts/ChatSessionsContext";

export default function Header() {
  const { userInfo, updateUserInfo } = useUserInfoContext();
  const { resetSelectedChatSession, handleDrawerToggle } = useChatSessionsContext();

  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    updateUserInfo(null);
    navigate("/");
  };

  const handleCreateAccount = () => {
    navigate("/createAccount")
  }

  return (
    <>
      <Box>
        <AppBar
          position="static"
          sx={{
            background: "rgba(0, 0, 0, 0.87)",
            color: "white",
            height: "7vh",
          }}
        >
          <Grid container sx={{ height: "7vh" }}>
            <Box
              sx={{
                height: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                px: "1vh",
              }}
            >
              {userInfo != null && (
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  sx={{ mr: 2, display: { lg: "none" } }}
                >
                  <MenuIcon />
                </IconButton>
              )}
              <NavLink
                to="/chat"
                onClick={() => {
                  resetSelectedChatSession(); // Reset the context
                }}
                style={{
                  textDecoration: "none",
                  color: "white",
                  width: "100%",
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  {/* Replace with app logo */}
                  <img
                    src={logo}
                    alt="slalom"
                    style={{
                      width: "65px",
                      height: "65px",
                      marginRight: "10px"
                    }}
                  />
                  {/* <Typography
                    sx={{
                      marginLeft: "5px",
                      marginRight: "5px",
                    }}
                    variant="h6"
                  >
                    |
                  </Typography> */}
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "26px",
                    }}
                    variant="h6"
                  >
                    {config.styledText}
                  </Typography>
                </Box>
              </NavLink>
              <Divider />
              <Divider />
              {userInfo != null && (
                <>
                  <Button sx={{display: userInfo.groups?.includes("Admin") ? "unset": "none", minWidth: "175px", marginRight: "10px"}} variant="contained" onClick={handleCreateAccount}>
                    Create Account
                  </Button>
                  <Button variant="contained" onClick={handleLogout}>
                    Logout
                  </Button>
                </>
              )}
            </Box>
          </Grid>
        </AppBar>
      </Box>
      <Outlet />
    </>
  );
}
